module.exports = __webpack_public_path__ + "img/navidad.65442fc7.jpg";